import React from 'react'

import { Field } from 'formik'

export const Tooltip = ({ tooltip, openAccordion, openAccordions }) => {
    return tooltip && tooltip.map((item, index)=> (
        <div key={index} className="form-field--service__item">
            <label>
                <Field type="checkbox" name="checked" value={item.title}/>
                <span>{item.title}</span>
            </label>
            <div className="form-field--service__tooltip">
                <svg width="24" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-info">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
                <div className="form-field--service__tooltip-desc">
                    <p className="whitespace--prewrap text-white bold" dangerouslySetInnerHTML={{ __html: item.content.content }} />
                </div>
            </div>
            {item.subtext && (<span className="form-field--service__notes">{item.subtext}</span>)}
            <div className="form-field--service__accordion">
                <div
                    onClick={() => openAccordion(index)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                        openAccordion(index);
                        }
                    }}
                    role="button"
                    tabIndex={0}
                    className="form-field--service__accordion-icon"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus">
                        {openAccordions[index] ? '' : <line x1="12" y1="5" x2="12" y2="19"></line>}
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                </div>
                <p className="whitespace--prewrap text-white" style={{ display: openAccordions[index] ? 'block' : 'none' }} dangerouslySetInnerHTML={{ __html: item.content.content }} />
            </div>
        </div>
    ))
}